"use client";

import HoldersTable from "@/components/app/holders/holders-table";

interface HoldersTabProps {
  publicKey: string;
}

export const HoldersTab = ({ publicKey }: HoldersTabProps) => {
  if (!publicKey) return null;

  return (
    <div className="overflow-hidden">
      <HoldersTable
        height={600}
        publicKey={publicKey}
        className="rounded-2xl border border-border"
        showHoldersSearch={true}
      />
    </div>
  );
};
